"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEmployee = addEmployee;
exports.complete = complete;
exports.create = create;
exports["default"] = void 0;
exports.deleteSegment = deleteSegment;
exports.getByProject = getByProject;
exports.getOne = getOne;
exports.orderDown = orderDown;
exports.orderUp = orderUp;
exports.typeahead = typeahead;
exports.update = update;

var _api = _interopRequireWildcard(require("./api"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function create(segmentFormData) {
  var segmentData = segmentFormData;
  return _api["default"].post('/api/segment', segmentData).then(_api.extractData)["catch"](_api.errorHandler);
}

function update(segmentId, segmentFormData) {
  var segmentData = (0, _omit["default"])(segmentFormData, ['projectId']);
  return _api["default"].post("/api/segment/".concat(segmentId), segmentData).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteSegment(segmentId) {
  return _api["default"]["delete"]("/api/segment/".concat(segmentId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getByProject(projectId) {
  return _api["default"].get("/api/segment/project/".concat(projectId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getOne(segmentId) {
  return _api["default"].get("/api/segment/".concat(segmentId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function complete(segmentId, value) {
  var payload = {
    complete: value
  };
  return _api["default"].post("/api/segment/".concat(segmentId, "/complete"), payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function orderDown(segmentId) {
  return _api["default"].post("/api/segment/".concat(segmentId, "/order-down")).then(_api.extractData)["catch"](_api.errorHandler);
}

function orderUp(segmentId) {
  return _api["default"].post("/api/segment/".concat(segmentId, "/order-up")).then(_api.extractData)["catch"](_api.errorHandler);
}

function typeahead(query, searchBy) {
  var urls = {
    positions: '/api/position/typeahead?q=',
    companies: '/api/company/typeahead?q=',
    employees: '/api/employee/typeahead?positions=ANALYST&q='
  };
  return _api["default"].get(urls[searchBy] + query).then(_api.extractData)["catch"](_api.errorHandler);
}

function addEmployee(segmentId, employeeId) {
  return _api["default"].post("/api/segment/".concat(segmentId, "/employee"), {
    employeeId: employeeId
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  create: create,
  update: update,
  deleteSegment: deleteSegment,
  getByProject: getByProject,
  getOne: getOne,
  complete: complete,
  orderDown: orderDown,
  orderUp: orderUp,
  typeahead: typeahead,
  addEmployee: addEmployee
};
var _default = api;
exports["default"] = _default;